import { defineEntity, number, object, string } from '~/prix'

const productMetricMonitor = defineEntity({
  key: 'productMetric',
  title: 'Produto Monitor',
  sources: ['oltp', 'olap'],
  entitySchema: 'monitor',
  schema: object({
    id: number().label('ID'),
    date: string().label('Data'),
    state: string().label('Estado'),
    productCode: string().label('Código do produto'),
    productDescription: string().label('Descrição do produto'),
    value: number().label('Contagem registrada'),
    createdAt: string().label('Criado em'),
    updatedAt: string().label('Atualizado em'),
    kpiId: string().label('ID do KPI'),
    kpiDescription: string().label('Descrição do KPI'),
    portfolio: string().label('Portfólio'),
  }),
})

export default productMetricMonitor
